// ============================================
// FAQ 知识中心 — 图片/文件上传服务
// 复刻 zlcggb-home 的 tutorialService.uploadImage
// ============================================

import { supabase } from '../config/supabase';
import { normalizeFaqSpaceSlug } from './faq-space-utils';

const BUCKET = 'faq-center';

async function getUserScopedStoragePath(file: File, folder?: string, spaceSlug = 'faq') {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('请先登录后再上传文件');

  const ext = file.name.split('.').pop() ?? 'bin';
  const fileName = `${crypto.randomUUID()}.${ext}`;
  const normalizedSpaceSlug = normalizeFaqSpaceSlug(spaceSlug);
  return folder
    ? `${normalizedSpaceSlug}/${user.id}/${folder}/${fileName}`
    : `${normalizedSpaceSlug}/${user.id}/${fileName}`;
}

/**
 * 上传图片到 Supabase Storage faq-center 桶
 * 返回公开 CDN URL
 */
export async function uploadFaqImage(file: File, spaceSlug?: string): Promise<string> {
  const fileName = await getUserScopedStoragePath(file, undefined, spaceSlug);

  const { error } = await supabase.storage
    .from(BUCKET)
    .upload(fileName, file, { cacheControl: '31536000', upsert: false });

  if (error) throw error;

  const { data } = supabase.storage
    .from(BUCKET)
    .getPublicUrl(fileName);

  return data.publicUrl;
}

/**
 * 上传任意文件到 Supabase Storage faq-center 桶
 * 返回 { url, name, size, type }
 */
export async function uploadFaqFile(file: File, spaceSlug?: string): Promise<{
  url: string;
  name: string;
  size: number;
  type: string;
}> {
  const fileName = await getUserScopedStoragePath(file, 'attachments', spaceSlug);

  const { error } = await supabase.storage
    .from(BUCKET)
    .upload(fileName, file, { cacheControl: '31536000', upsert: false });

  if (error) throw error;

  const { data } = supabase.storage
    .from(BUCKET)
    .getPublicUrl(fileName);

  return {
    url: data.publicUrl,
    name: file.name,
    size: file.size,
    type: file.type || 'application/octet-stream',
  };
}

/**
 * 删除 faq-center 桶中的文件
 */
export async function deleteFaqFile(fileName: string): Promise<void> {
  const { error } = await supabase.storage
    .from(BUCKET)
    .remove([fileName]);

  if (error) throw error;
}
